import * as React from 'react'
import { SVGProps } from 'react'
const SvgAddToCart = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 1114.11 1063.73" {...props}>
    <path
      className="cls-1"
      d="M792.49 533.04h-74.96l30.44 455.91H79.95l44.91-673.15h409.43v-74.79H54.86L0 1063.73h827.85l-35.36-530.69z"
    />
    <path
      className="cls-1"
      d="M595.99 197.27c-27.53-79.78-80.42-155.71-182.05-155.71-209.52 0-211.91 322.85-211.91 336.57v37.35l74.71.04.08-37.35c0-2.62 4.2-261.83 137.12-261.83S551.1 375.55 551.1 378.17l.08 37.35 44.82-.02V197.27Z"
    />
    <path
      className="cls-1"
      d="M798.31 0c-174.41 0-315.8 141.39-315.8 315.8s141.39 315.8 315.8 315.8 315.8-141.39 315.8-315.8S972.72 0 798.31 0Zm157.9 355.27H837.79v118.42c0 21.82-17.66 39.47-39.47 39.47s-39.47-17.66-39.47-39.47V355.27H640.43c-21.82 0-39.47-17.66-39.47-39.47s17.66-39.47 39.47-39.47h118.42V157.91c0-21.82 17.66-39.47 39.47-39.47s39.47 17.66 39.47 39.47v118.42h118.42c21.82 0 39.47 17.66 39.47 39.47s-17.66 39.47-39.47 39.47Z"
    />
  </svg>
)
export default SvgAddToCart
